import { GroupSortOrder } from '@ms/yammer-graphql';
import { Reducer } from 'redux';

import {
  AllNetworkGroupsLoadAction,
  AllNetworkGroupsLoadMoreAction,
} from '../../domains/allNetworkGroups/actions.types';

import { AllNetworkGroups, SortedGroupList } from './types';

export type AllNetworkGroupsAction = AllNetworkGroupsLoadAction | AllNetworkGroupsLoadMoreAction;

const initialState: AllNetworkGroups = {};

const initialSortedGroupList: SortedGroupList = {
  groupIds: [],
  cursor: null,
  hasNextPage: false,
  status: 'pending',
};

const loadPendingNetworkGroups = (state: AllNetworkGroups, sortBy: GroupSortOrder) => ({
  ...state,
  [sortBy]: initialSortedGroupList,
});

const loadRejectedNetworkGroups = (state: AllNetworkGroups, sortBy: GroupSortOrder) => ({
  ...state,
  [sortBy]: {
    ...initialSortedGroupList,
    status: 'rejected',
  },
});

const loadMoreRejectedNetworkGroups = (state: AllNetworkGroups, sortBy: GroupSortOrder) => ({
  ...state,
  [sortBy]: {
    ...state[sortBy],
    status: 'rejected',
  },
});

const loadMoreAllNetworkGroupsFulfilled = (state: AllNetworkGroups, data: Record<string, SortedGroupList>) => {
  const sortKey = Object.keys(data)[0];
  const sortBy: GroupSortOrder | undefined = (Object.keys(GroupSortOrder) as GroupSortOrder[]).find(
    (key) => GroupSortOrder[key] === sortKey
  );

  if (!sortBy) {
    return state;
  }

  const currentGroupIds = state[sortBy]?.groupIds ?? [];
  const groupIds = [...currentGroupIds, ...data[sortBy].groupIds];

  return {
    ...state,
    [sortBy]: {
      ...data[sortBy],
      groupIds,
    },
  };
};

const reducer: Reducer<AllNetworkGroups, AllNetworkGroupsAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'ALL_NETWORK_GROUPS.LOAD_PENDING':
      return loadPendingNetworkGroups(state, action.payload.sortBy);
    case 'ALL_NETWORK_GROUPS.LOAD_REJECTED':
      return loadRejectedNetworkGroups(state, action.payload.sortBy);
    case 'ALL_NETWORK_GROUPS.LOAD_MORE_REJECTED':
      return loadMoreRejectedNetworkGroups(state, action.payload.sortBy);
    case 'ALL_NETWORK_GROUPS.LOAD_FULFILLED':
      return { ...state, ...action.payload.entities.allNetworkGroups };
    case 'ALL_NETWORK_GROUPS.LOAD_MORE_FULFILLED':
      return loadMoreAllNetworkGroupsFulfilled(state, action.payload.entities.allNetworkGroups);
    default:
      return state;
  }
};

export default reducer;
